export default __webpack_public_path__ + "static/media/sv11_kr_head_a1.ef98d99b.mp3";